export default "__VITE_ASSET__l4YNfVt4__"